import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=bbc03168&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=bbc03168&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc03168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc03168')) {
      api.createRecord('bbc03168', component.options)
    } else {
      api.reload('bbc03168', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=bbc03168&scoped=true", function () {
      api.rerender('bbc03168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/activeCode/activeCodeGenerate/components/Detail.vue"
export default component.exports